var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_10240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48837 0 0 4.46512 0 10C0 15.5349 4.48837 20 10 20C15.5116 20 20 15.5349 20 10C20 4.46512 15.5116 0 10 0ZM10 4.77741C11.6013 4.77741 12.9103 6.0897 12.9103 7.68771C12.9103 9.28571 11.598 10.598 10 10.598C8.40199 10.598 7.0897 9.28571 7.0897 7.68771C7.0897 6.0897 8.40199 4.77741 10 4.77741ZM10 18.4219C7.28904 18.4219 4.86711 17.1329 3.31229 15.1329C4.57807 12.7542 7.11296 11.1329 10 11.1329C12.887 11.1329 15.4219 12.7542 16.6877 15.1329C15.1528 17.1329 12.711 18.4219 10 18.4219Z",
    fill: "#ABAFB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_10240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user-default.93d28ff37a94fb4c99409738d026529b.svg";
export { ForwardRef as ReactComponent };